import React, {CSSProperties, ReactElement} from 'react';
import {SubMenuTab} from './types';

interface SubMenuProps<TabContentProps> {
  tabs: SubMenuTab<TabContentProps>[];
  selectedTabs: number;
  onChange: (index: number) => void;
}

const Styles: Record<string, CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  tab: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 16,
    paddingBottom: 16,
    cursor: 'pointer',
  },
  selectedTab: {
    backgroundColor: 'white',
    fontWeight: 'bold',
  },
};

export const SubMenu: <TabContentProps>(
  props: SubMenuProps<TabContentProps>,
) => ReactElement = ({tabs, selectedTabs, onChange}) => {
  return (
    <div style={Styles.container}>
      {tabs.map((tab, index) => (
        <div
          onClick={() => onChange(index)}
          style={{
            ...Styles.tab,
            ...(selectedTabs === index && Styles.selectedTab),
          }}>
          {tab.label}
          {tab.isRequired && <span style={{color: 'red'}}> *</span>}
        </div>
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/SubMenu/index.tsx